module.exports = __webpack_public_path__ + "images/icon-error-914f033e9e426c05086de7b287ecc6f4.png";